import React, { useState, useEffect } from 'react';

export default function CorreoPlantillaModal({ open, mode, data, onClose, onSubmit }) {
    const [form, setForm] = useState({
        asuntoCorreo: '',
        contenidoCorreo: '',
        momento: '',
        enviar: false,
        activo: true,
        programarEnvio: false,
        diaEnvio: '',
        horaEnvio: '',
    });

    useEffect(() => {
        if (mode === 'edit' && data) {
            setForm({
                asuntoCorreo: data.asuntoCorreo || '',
                contenidoCorreo: data.contenidoCorreo || '',
                momento: data.momento || '',
                enviar: data.enviar ?? false,
                activo: data.activo ?? true,
                programarEnvio: data.programarEnvio ?? false,
                diaEnvio: data.diaEnvio || '',
                horaEnvio: data.horaEnvio || '',
            });
        } else {
            setForm({
                asuntoCorreo: '',
                contenidoCorreo: '',
                momento: '',
                enviar: false,
                activo: false,
                programarEnvio: false,
                diaEnvio: '',
                horaEnvio: '',
            });
        }
    }, [mode, data]);

    const handleChange = (field, value) => {
        setForm((prev) => {
            const next = { ...prev, [field]: value };
            if (field === 'programarEnvio') {
                next.enviar = value; // Sincroniza habilitación si se programa
            }
            return next;
        });
    };

    const handleSubmit = () => {
        onSubmit(form, mode);
    };

    if (!open) return null;

    const Header = (
        <div
            className="roles-topbar"
            style={{
                marginBottom: '0.6rem',
                paddingRight: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flex: '0 0 auto',
            }}>
            <h3 className="roles-title" style={{ marginRight: 0 }}>
                {mode === 'new' ? 'Nueva Plantilla (Intranet)' : 'Editar Plantilla (Intranet)'}
            </h3>
            <button className="roles-btn" onClick={onClose} aria-label="Cerrar">
                ✕
            </button>
        </div>
    );

    const Body = (
        <div
            style={{
                paddingLeft: '5%',
                paddingRight: 16,
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: '0.8rem',
                overflowY: 'auto',
                flex: '1 1 auto',
                minHeight: 0,
            }}>

            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Momento:</label>
                <br /><br />
                <input
                    className="infoField"
                    value={form.momento}
                    onChange={(e) => handleChange('momento', e.target.value)}
                    maxLength={250}
                />
            </div>

            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Asunto:</label>
                <br /><br />
                <input
                    className="infoField"
                    value={form.asuntoCorreo}
                    onChange={(e) => handleChange('asuntoCorreo', e.target.value)}
                    required
                    maxLength={250}
                />
            </div>

            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Contenido:</label>
                <br /><br />
                <textarea
                    className="infoField"
                    value={form.contenidoCorreo}
                    onChange={(e) => handleChange('contenidoCorreo', e.target.value)}
                    rows={8}
                    style={{ resize: 'vertical' }}
                />
            </div>

            {/* Controles de Envío */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '10px' }}>
                
                {/* Toggle Enviar */}
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between', 
                    padding: '12px', 
                    backgroundColor: '#f8fafc', 
                    borderRadius: '10px', 
                    border: '1px solid #e2e8f0' 
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontSize: '.9rem', fontWeight: 700, color: '#1e293b' }}>Habilitar Envío</span>
                        <span style={{ fontSize: '.75rem', color: '#64748b' }}>Permite que el correo se envíe manualmente o masivamente.</span>
                    </div>
                    <div
                        onClick={() => handleChange('enviar', !form.enviar)}
                        style={{
                            width: '44px',
                            height: '22px',
                            backgroundColor: form.enviar ? '#10b981' : '#cbd5e1',
                            borderRadius: '12px',
                            position: 'relative',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                        }}
                    >
                        <div style={{
                            width: '16px',
                            height: '16px',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            position: 'absolute',
                            top: '3px',
                            left: form.enviar ? '25px' : '3px',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.2)'
                        }} />
                    </div>
                </div>

                {/* Toggle Programación */}
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between', 
                    padding: '12px', 
                    backgroundColor: form.programarEnvio ? '#f0f7ff' : '#f8fafc', 
                    borderRadius: '10px', 
                    border: '1px solid',
                    borderColor: form.programarEnvio ? '#bae6fd' : '#e2e8f0',
                    transition: 'all 0.3s'
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontSize: '.9rem', fontWeight: 700, color: form.programarEnvio ? '#0369a1' : '#1e293b' }}>Envío Automático Programado</span>
                        <span style={{ fontSize: '.75rem', color: '#64748b' }}>Habilitar la programación por día y hora (Hangfire).</span>
                    </div>
                    <div
                        onClick={() => handleChange('programarEnvio', !form.programarEnvio)}
                        style={{
                            width: '44px',
                            height: '22px',
                            backgroundColor: form.programarEnvio ? '#0ea5e9' : '#cbd5e1',
                            borderRadius: '12px',
                            position: 'relative',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                        }}
                    >
                        <div style={{
                            width: '16px',
                            height: '16px',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            position: 'absolute',
                            top: '3px',
                            left: form.programarEnvio ? '25px' : '3px',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.2)'
                        }} />
                    </div>
                </div>

                {form.programarEnvio && (
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '5px' }}>
                        <div>
                            <label className="roles-title" style={{ fontSize: '.85rem' }}>Día de la Semana:</label>
                            <select
                                className="infoField"
                                value={form.diaEnvio}
                                onChange={(e) => handleChange('diaEnvio', e.target.value)}
                            >
                                <option value="">Seleccionar día...</option>
                                <option value="1">Lunes</option>
                                <option value="2">Martes</option>
                                <option value="3">Miércoles</option>
                                <option value="4">Jueves</option>
                                <option value="5">Viernes</option>
                                <option value="6">Sábado</option>
                                <option value="7">Domingo</option>
                            </select>
                        </div>
                        <div>
                            <label className="roles-title" style={{ fontSize: '.85rem' }}>Hora de Envío:</label>
                            <input
                                type="time"
                                className="infoField"
                                value={form.horaEnvio}
                                onChange={(e) => handleChange('horaEnvio', e.target.value)}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

    const Footer = (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '.6rem',
                marginTop: '.8rem',
                paddingRight: 16,
                flex: '0 0 auto',
            }}
        >
            <button className="roles-btn" onClick={onClose}>Cancelar</button>
            <button
                className="btn-action"
                onClick={handleSubmit}
                disabled={!form.asuntoCorreo}
                style={{
                    opacity: !form.asuntoCorreo ? 0.5 : 1,
                    cursor: !form.asuntoCorreo ? 'not-allowed' : 'pointer',
                }}
            >
                {mode === 'new' ? 'Guardar' : 'Actualizar'}
            </button>
        </div>
    );

    return (
        <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {Header}
            {Body}
            {Footer}
        </div>
    );
}
